import { Controller } from "stimulus";
import Hls from "hls.js";

// Plays an HLS-only video asset (a live recording has no MP4 rendition) in the plain <video>
// preview, which can't take an .m3u8 <source> outside Safari. Mirrors media--video-player's
// engine choice: hls.js wherever it runs except Safari, whose native HLS gets the master as src.
// The master is cookie-signed (or a cookie-setting bounce URL), so every request must carry
// credentials. Steps aside the moment the upload controller drops a local <source> in for a
// reupload, so that preview wins over the old recording.
export default class extends Controller {
  static values = { url: String };

  connect() {
    if (!this.urlValue) return;

    this.observer = new MutationObserver(() => this.releaseForLocalSource());
    this.observer.observe(this.element, { childList: true });

    if (Hls.isSupported() && !window.WebKitPlaybackTargetAvailabilityEvent) {
      this.hls = new Hls({ xhrSetup: (xhr) => { xhr.withCredentials = true; } });
      this.hls.loadSource(this.urlValue);
      this.hls.attachMedia(this.element);
    } else if (this.element.canPlayType("application/vnd.apple.mpegurl")) {
      this.element.src = this.urlValue;
    }
  }

  disconnect() {
    if (this.observer) this.observer.disconnect();
    this.destroyHls();
  }

  releaseForLocalSource() {
    if (!this.element.querySelector("source")) return;

    this.observer.disconnect();
    this.destroyHls();
    this.element.removeAttribute("src");
    this.element.load();
  }

  destroyHls() {
    if (!this.hls) return;

    this.hls.destroy();
    this.hls = null;
  }
}
